import { createBrowserClient } from "@supabase/ssr";
import { supabaseCreds } from "./config";

export const supabaseAnonClient = createBrowserClient(
  supabaseCreds.supabaseUrl,
  supabaseCreds.supabaseAnonKey,
  {
    auth: {
      storage: {
        getItem: (key) => {
          if (typeof document === "undefined") return null; // Ensure document is available
          const cookies = document.cookie.split("; ");
          const cookieValue = cookies
            .find((row) => row.startsWith(`${key}=`))
            ?.split("=")[1];
          if (!cookieValue) {
            return null;
          }
          let decodedValue = decodeURIComponent(cookieValue);
          if (decodedValue.startsWith("base64-")) {
            decodedValue = atob(decodedValue.slice(7));
            return JSON.parse(decodedValue);
          }
          return decodedValue || null;
        },
        setItem: (key, value) => {
          if (typeof document !== "undefined") {
            document.cookie = `${key}=${encodeURIComponent(value)}; path=/`;
          }
        },
        removeItem: (key) => {
          if (typeof document !== "undefined") {
            document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
          }
        },
      },
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  }
);
